import React, { useState, Fragment } from 'react'
import Button from '../../Button'
import Icon, { IconType } from '../../Icon'
import AttachmentsListItem from '../AttachmentsListItem'
import AttachmentProcessing from '../AttachmentProcessing'
import { AttachmentsListsProps } from './../types'
import styles from '@bt-react/styles'
import componentStyles from './AttachmentsLists.module.scss'
import { useDrop } from 'react-dnd'
import update from 'immutability-helper'
import compareAsc from 'date-fns/compareAsc'
import subMinutes from 'date-fns/subMinutes'
import classNames from 'classnames'
import { useEffect } from 'react'
import { useIsNarrowView } from '../../Attachments/Attachments'

const AttachmentsLists: React.FC<AttachmentsListsProps> = ({setView, resourceData, status, activeResource, webcastData, rearrangeResource, deleteResource, isCentral}) => {

    const [list, setList] = useState(resourceData)
    const syndication = (webcastData.syndication && Object.keys(webcastData.syndication).length > 0 && webcastData.syndication.syndicationIn) ? true : false
    const currentTime = new Date()
    const isLive = (webcastData.entryTime && webcastData.closeTime && compareAsc(subMinutes(new Date(webcastData.entryTime), 10), currentTime) <= 0  && compareAsc(currentTime, new Date(webcastData.closeTime)) <= 0) ? true : false


    useEffect(() => {
        setList(resourceData)
    }, [resourceData])

    const moveList = (id: string, atIndex: number) => {
        const { l, index } = findList(id)
        const newList =  update(list, {
            $splice: [
              [index, 1],
              [atIndex, 0, l],
            ],
          })
        setList(
         newList
        )
        const data = newList.map((list)=> ({id: list.id}))
        if (typeof webcastData.channel.id !== 'undefined' && typeof webcastData.id !== 'undefined') {
            rearrangeResource(webcastData.channel.id.toString(), webcastData.id.toString(), data)
        }
    }
    
    const findList = (id: string) => {
        const l = list.filter((c) => `${c.id}` === `${id}`)[0]
        return {
          l,
          index: list.indexOf(l),
        }
    }

    const [, drop] = useDrop({ accept: 'lists' })

    const isNarrowView = useIsNarrowView()

    return (
        <div className={classNames({
          [componentStyles['attachments-lists-container']]: true,
          [componentStyles['attachments-lists-container-narrow']]: isNarrowView
        })} data-bdd="attachments-lists">            
            <div data-bdd="attachments-lists-instruction-text" className={classNames(isLive ? componentStyles['bt-header-font'] : styles['font-weight-bold'], componentStyles['header-text'])}>
                {!syndication && !isLive &&
                    "Add a file or link to a file"
                }
                {(isLive) &&
                    "Changes to attachments cannot be made starting 15 minutes before the live event. Please check back after the event has ended."
                }
            </div>
            {(!activeResource || (!status.isUploading && !status.isProcessing))  &&
                <Fragment>
                    {!syndication && !isLive &&
                        <Button 
                            onClick={()=>setView('add')}
                            dataBdd="add-attachment-button"
                            className={classNames(componentStyles['add-attachment-button'], {[componentStyles['add-attachment-button-central']]: isCentral})}
                        >
                            <Icon
                                name={isCentral ? IconType.iconName.plusCircleRegular : IconType.iconName.plusCircle}
                                colour={IconType.colour.white}
                                className={classNames(componentStyles['add-icon'], {[componentStyles['add-icon-central']]: isCentral})}
                            />
                            Add attachment
                        </Button>
                    }
                    <div ref={(node) => { drop(node) }}>
                        {list.map((resource) => {
                            return <AttachmentsListItem
                                key={resource.id}
                                data={resource}
                                readonly={syndication || isLive}
                                moveList={moveList}
                                findList={findList}
                                isCentral={isCentral}
                            /> 
                        })}
                    </div>
                </Fragment>
            }
            {(status.isUploading || status.isProcessing) && activeResource &&
                <Fragment>
                    <AttachmentProcessing webcastId={String(webcastData.id)} channelId={String(webcastData.channel.id)} data={activeResource} readonly={syndication || isLive} isCentral={isCentral}/>
                    <Button 
                        onClick={()=>{
                            deleteResource(webcastData.channel.id, webcastData.id, activeResource.target ? activeResource.target.id : activeResource.id, status.isProcessing ? 'back' : 'cancel')
                            if(status.isProcessing) setView('list')
                        }}
                        data-bdd="back-button"
                        color={IconType.colour.link}
                        className={classNames(styles['pl-0'], componentStyles['back-button'])}
                    >
                        <Icon name={isCentral ? IconType.iconName.angleLeftRegular : IconType.iconName.angleLeft} className={componentStyles['back-icon']} />
                        Back
                    </Button>
                </Fragment>
            }
        </div>
    )

}

export default AttachmentsLists